module.exports = __webpack_public_path__ + "e4a24147be9682fa42c212d70b6f1058.svg";